import axios from "axios";
import React from "react";
import Nav from "react-bootstrap/Nav";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const NavItem = ({ elm, download, dates }) => {
  const placement = "top";
  const defaultUrl = axios.defaults.baseURL;

  function onClickIcon() {
    const uri = `${defaultUrl}${download.url}&start=${dates[0]}&end=${dates[1]}`;
    window.location = uri;
  }

  const CustomToltip = () => (
    <OverlayTrigger
      key={placement}
      placement={placement}
      overlay={<Tooltip id={`tooltip-${placement}`}>{download.label}</Tooltip>}
    >
      <i
        onClick={onClickIcon}
        className="fas fa-download"
        style={{ color: "#f40105" }}
      />
    </OverlayTrigger>
  );

  return (
    <Nav.Item>
      <Nav.Link eventKey={elm.key}>
        <span style={{ marginRight: "1rem" }}>{elm.label}</span>
        <CustomToltip />
      </Nav.Link>
    </Nav.Item>
  );
};

export default NavItem;
